import React from "react"

import { SsnInput } from "../../Input"


const renderSsnInput = (itemProps, inputProps, form, path) => {
  return (
    <SsnInput
      form={form}
      itemProps={itemProps}
      inputProps={inputProps}
      path={path}
    />
  )
}

export default renderSsnInput
